import _createForOfIteratorHelper from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
export var createMonitorConnections = function createMonitorConnections(insertElementInSet, isNativeAudioNode) {
  return function (nativeAudioNode, whenConnected, whenDisconnected) {
    var connections = new Set();
    nativeAudioNode.connect = function (connect) {
      // tslint:disable-next-line:invalid-void no-inferrable-types
      return function (destination) {
        var output = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var input = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var wasDisconnected = connections.size === 0;
        if (isNativeAudioNode(destination)) {
          // @todo TypeScript cannot infer the overloaded signature with 3 arguments yet.
          connect.call(nativeAudioNode, destination, output, input);
          insertElementInSet(connections, [destination, output, input], function (connection) {
            return connection[0] === destination && connection[1] === output && connection[2] === input;
          }, true);
          if (wasDisconnected) {
            whenConnected();
          }
          return destination;
        }
        connect.call(nativeAudioNode, destination, output);
        insertElementInSet(connections, [destination, output], function (connection) {
          return connection[0] === destination && connection[1] === output;
        }, true);
        if (wasDisconnected) {
          whenConnected();
        }
        return;
      };
    }(nativeAudioNode.connect);
    nativeAudioNode.disconnect = function (disconnect) {
      return function (destinationOrOutput, output, input) {
        var wasConnected = connections.size > 0;
        if (destinationOrOutput === undefined) {
          disconnect.apply(nativeAudioNode);
          connections.clear();
        } else if (typeof destinationOrOutput === 'number') {
          // @todo TypeScript cannot infer the overloaded signature with 1 argument yet.
          disconnect.call(nativeAudioNode, destinationOrOutput);
          var _iterator = _createForOfIteratorHelper(connections),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var connection = _step.value;
              if (connection[1] === destinationOrOutput) {
                connections.delete(connection);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        } else {
          if (isNativeAudioNode(destinationOrOutput)) {
            // @todo TypeScript cannot infer the overloaded signature with 3 arguments yet.
            disconnect.call(nativeAudioNode, destinationOrOutput, output, input);
          } else {
            // @todo TypeScript cannot infer the overloaded signature with 2 arguments yet.
            disconnect.call(nativeAudioNode, destinationOrOutput, output);
          }
          var _iterator2 = _createForOfIteratorHelper(connections),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _connection = _step2.value;
              if (_connection[0] === destinationOrOutput && (output === undefined || _connection[1] === output) && (input === undefined || _connection[2] === input)) {
                connections.delete(_connection);
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
        var isDisconnected = connections.size === 0;
        if (wasConnected && isDisconnected) {
          whenDisconnected();
        }
      };
    }(nativeAudioNode.disconnect);
    return nativeAudioNode;
  };
};